<template>
  <div class="current-asset-container">
    <div class="current-asset-content">
      <div :class="`color-${asset.type.toLowerCase()}`" />
      <BaseText
        size="lg"
        class="current-asset-name"
        :color="NebraskaColors.elementPrimary"
        >{{ asset.name }}</BaseText
      >
    </div>
    <BaseText
      v-if="percent !== '0'"
      size="lg"
      class="current-asset-name"
      :color="NebraskaColors.elementPrimary"
      >{{ percent }}</BaseText
    >
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';

import { Heading, BaseText } from '@warrenbrasil/nebraska-web';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

import { Assets } from '../../types';

@Component({
  components: {
    Heading,
    BaseText
  }
})
export default class AssetInfo extends Vue {
  public NebraskaColors = NebraskaColors;

  @Prop({ type: Object, required: true })
  public asset!: Assets;

  @Prop({ type: String, required: false, default: '0' })
  public percent!: string;
}
</script>

<style lang="less" scoped>
.current-asset-content {
  display: flex;
  align-items: center;
  :first-child {
    margin-right: @size-spacing-x150;
    height: 12px;
    width: 12px;
    border-radius: 100%;
  }
}

.current-asset-container {
  display: flex;
  align-content: center;
  justify-content: space-between;
}

.color-fixedincome {
  background-color: @asset-fixed-income;
}

.color-variableincome {
  background-color: @asset-stocks;
}

.color-others {
  background-color: @asset-others;
}

.current-asset-name {
  font-weight: 600;
}
</style>
